import * as position from './position'
import * as user from './user'
import * as vita from './vita'
import * as customer from './customer'
import * as dormitory from './dormitory'
export default {
  position,
  user,
  vita,
  customer,
  dormitory
}
